import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob, showAlert } from '../../lib/helpers';
import { dataIntervalUpload } from '../params';
import {
  postApi,
  handleStoreApiError,
  handleApiError,
} from '../../lib/fetcher';

const maintenanceSettlement = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      listMerchant: [],
      totalMerchants: 0,
      loading: false,
      loadingListMerchant: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      countSame: 0,
      countDone: 0,
      countData: 0,
      totalPage: 0,
      requestListMerchant: null,
      requestData: null,
      uploadProgress: 0,
      onUpload: false,
      insertProgress: 0,
      insertName: '',
      onInsert: false,
      countSuccess: 0,
      countFailed: 0,
      downloadFailedURL: '',
      intervalImport: null,
      importId: null,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    clearErrorVariable(state, variable) {
      state.errors = { ...state.errors, [variable]: [] };
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setCancelationRLMerchant(state, payload) {
      state.requestListMerchant = payload;
    },

    setLoadingListMerchant(state, loading) {
      state.loadingListMerchant = loading;
    },

    setDetailMerchant(state, { payload }) {
      state.merchant = payload;
    },
    setMerchantVariable(state, { variable, payload }) {
      state.merchant[variable] = payload;
    },

    setListMerchant(state, payload) {
      state.listMerchant = payload;
    },

    removeOutlet(state, { index }) {
      state.totalMerchants -= 1;
      state.allMerchants = state.allMerchants.filter(
        (value) => value.id != index
      );
    },

    editOutlet(state, { payload, index }) {
      Object.assign(state.allMerchants[index], payload);
    },
    setCancelation(state, payload) {
      state.requestData = payload;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    clearLastResult(state) {
      state.countData = 0;
      state.countSuccess = 0;
      state.countFailed = 0;
      state.countDone = 0;
      state.countSame = 0;
      state.uploadProgress = 0;
      state.onUpload = false;
      state.insertProgress = 0;
      state.onInsert = false;
      state.insertName = '';
      state.intervalImport = null;
      state.importId = null;
      state.downloadFailedURL = '';
    },
    setOnUpload(state, onUpload) {
      state.onUpload = onUpload;
    },
    setUploadProgress(state, uploadProgress) {
      state.uploadProgress = uploadProgress;
    },
    setImportData(state, payload) {
      state.importId = payload.import_id;
      state.countData = payload.count_data;
    },
    setIntervalImport(state, payload) {
      state.intervalImport = payload;
    },
    setInsertName(state, insertName) {
      state.insertName = insertName;
    },
    setOnInsert(state, onInsert) {
      state.onInsert = onInsert;
    },
    setDownloadFailedURL(state, payload) {
      state.downloadFailedURL = payload;
    },
    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },
  },

  actions: {
    async validate(ctx, { date, no_rekening }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();
      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      const data = JSON.stringify({
        account_number: no_rekening,
        version: btoa(
          CryptoJS.SHA256(
            no_rekening +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/onboarding/rekening/validate-rekening`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      let returnVal = false;
      if (responseData?.code == 200) {
        returnVal = true;
      }
      return returnVal;
    },
    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, merchantId }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const merchantIdVal = merchantId == null ? '' : merchantId;

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        merchant_id: merchantIdVal.toString(),
        version:
          merchantIdVal == ''
            ? btoa(
              CryptoJS.SHA256(
                itemsPerPage.toString() +
                    page.toString() +
                    date +
                    atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            )
            : btoa(
              CryptoJS.SHA256(
                merchantIdVal.toString() +
                    sort_by.toString() +
                    itemsPerPage.toString() +
                    page.toString() +
                    date +
                    atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
      });
      const urlApi = `/index.php?r=api/v1/maintenance_setlement/settlement/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async updateMerchant(
      ctx,
      { date, id, account_number, approver_1, approver_2 }
    ) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        account_number,
        approver_1,
        approver_2,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/maintenance_setlement/settlement/update`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 302) {
        const resData = responseData?.data;
        const errorMessage =
          (typeof resData === 'string' && resData) ||
          (typeof resData?.message === 'string' && resData.message);
        if (errorMessage) {
          showAlert(ctx, errorMessage, 'mdi-alert', 'red');
        }
        return false;
      }

      if (responseData?.code != '200') {
        handleStoreApiError(ctx, responseData);
      } else {
        showAlert(ctx, 'Update Success !', 'mdi-check-circle', 'green');
        return true;
      }
      return false;
    },

    async getListMerchant(ctx, { date, searchMerchant }) {
      if (ctx.state.requestListMerchant) ctx.state.requestListMerchant.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationRLMerchant', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoadingListMerchant', true);

      const data = JSON.stringify({
        search: searchMerchant,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/maintenance_setlement/settlement/list-merchant`;
      const addConfig = { cancelToken: axiosSource.token };
      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == '200') {
        return responseData.data;
      }
      ctx.commit('setLoadingListMerchant', false);
      return false;
    },

    async generateMerchant(ctx, { date, merchant_id }) {
      const data = JSON.stringify({
        account_id: merchant_id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/maintenance_setlement/settlement/download-settlement`;
      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        return responseData.data;
      }
      return false;
    },

    async bulkUpload(ctx, { file, date }) {
      const data = new FormData();
      data.append('file', file);
      ctx.commit('setOnUpload', true);
      ctx.commit(
        'setInsertProgressGlobal',
        {
          absoluteBar: true,
          absoluteBarText: 'Uploading...',
        },
        { root: true }
      );

      const failed = () => {
        ctx.commit('setOnUpload', false);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Upload Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
      };

      const urlApi = `/index.php?r=api/v1/maintenance_setlement/bulk-settlement/import`;

      const addConfig = {
        onUploadProgress(progressEvent) {
          ctx.commit(
            'setUploadProgress',
            parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100),
              10
            )
          );
        },
      };
      try {
        const responseData = await postApi(ctx, urlApi, data, addConfig);

        if (responseData?.code == '200') {
          ctx.commit('setImportData', responseData.data);
          const interval = setInterval(() => {
            ctx.dispatch('importStatus', {
              date,
            });
          }, dataIntervalUpload);
          ctx.commit('setIntervalImport', interval);
          ctx.commit('setInsertName', 'Start to insert data..');
          ctx.commit('setOnInsert', true);
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: true,
              absoluteBarText: 'Start to insert data..',
            },
            { root: true }
          );
        } else {
          failed();
          if (responseData.code == '302') {
            showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
          }
        }
        ctx.commit('setOnUpload', false);
        return responseData;
      } catch (error) {
        failed();
        return false;
      }
    },

    async downloadTemplate(ctx, { action }) {
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'add':
            return 'bulk-upload-merchant';
          case 'update-pten':
            return 'bulk-update-merchant';
          case 'update-non-pten':
            return 'bulk-update-merchant';
          default:
            return 'bulk-upload-merchant';
        }
      };
      const config = {
        method: 'post',
        url: `${
          process.env.VUE_APP_API_BASE_URL
        }/index.php?r=api/v1/onboarding/${controller(action)}/download`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
      };
      return axios(config)
        .then((response) => response.data)
        .catch((error) => {
          handleApiError(ctx, error.response);
          return null;
        });
    },

    async importStatus(ctx, { date }) {
      const data = JSON.stringify({
        import_id: ctx.state.importId,
        count_data: ctx.state.countData,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.importId.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const setCountToDefault = () => {
        ctx.commit('setStateVariable', {
          payload: 0,
          variable: 'countDone',
        });
        ctx.commit('setStateVariable', {
          payload: 0,
          variable: 'countSame',
        });
      };

      const failed = () => {
        clearInterval(ctx.state.intervalImport);
        ctx.commit('setOnInsert', false);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Upload Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        setCountToDefault();
      };

      try {
        const urlApi = `/index.php?r=api/v1/maintenance_setlement/bulk-settlement/status-import`;

        const responseData = await postApi(ctx, urlApi, data);

        if (responseData.code == '00') {
          clearInterval(ctx.state.intervalImport);
          ctx.commit('setOnInsert', false);
          ctx.commit('setStateVariable', {
            variable: 'countSuccess',
            payload: responseData.data.count_success,
          });
          ctx.commit('setStateVariable', {
            variable: 'countFailed',
            payload: responseData.data.count_failed,
          });
          if (responseData.data.count_success != ctx.state.countData) {
            ctx.dispatch('downloadFailedImport', {
              date,
            });
          } else {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: 'Success, Bulk Upload Done !',
                icon: 'mdi-alert',
                color: 'green',
              },
              { root: true }
            );
          }
          setCountToDefault();
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: false,
              absoluteBarText: '',
            },
            { root: true }
          );
        } else if (responseData.code == '302') {
          failed();
        } else {
          const totalDataDone =
            parseInt(responseData.data.count_success, 10) +
            parseInt(responseData.data.count_failed, 10);
          ctx.commit(
            'setInsertName',
            `Insert ${totalDataDone}/${ctx.state.countData} data..`
          );
          ctx.commit(
            'setInsertProgress',
            (totalDataDone / ctx.state.countData) * 100
          );
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: true,
              absoluteBarText: `Insert ${totalDataDone}/${ctx.state.countData} data..`,
            },
            { root: true }
          );
          if (ctx.state.countDone != totalDataDone) {
            ctx.commit('setStateVariable', {
              payload: totalDataDone,
              variable: 'countDone',
            });
            ctx.commit('setStateVariable', {
              payload: 0,
              variable: 'countSame',
            });
          } else {
            ctx.commit('setStateVariable', {
              payload: ctx.state.countSame + 1,
              variable: 'countSame',
            });
          }
          if (ctx.state.countSame > 2) {
            failed();
          }
        }
      } catch (error) {
        failed();
      }
    },

    async downloadFailedImport(ctx, { date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        import_id: ctx.state.importId,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.importId.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/maintenance_setlement/bulk-settlement/download-failed-import`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      await axios(config)
        .then((response) => {
          if (response.data.code == 200) {
            ctx.commit('setDownloadFailedURL', response.data.data.download);
          }
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        })
        .finally(() => {
          ctx.commit('setLoading', false);
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: 'Upload done with some failed record !',
              icon: 'mdi-alert',
              color: 'orange',
            },
            { root: true }
          );
        });
    },
  },
};
export default maintenanceSettlement;
